// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 404 Not Found Page - Professional yet Playful */

.not-found-container {
  min-height: calc(100vh - 300px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.not-found-content {
  max-width: 800px;
  text-align: center;
  padding: 2rem;
}

/* Animated 404 Section */
.error-code-section {
  margin-bottom: 3rem;
}

.error-code {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.error-digit {
  font-size: 8rem;
  font-weight: 900;
  font-family: var(--font-serif);
  color: var(--primary-navy);
  text-shadow: 0 4px 8px rgba(0, 51, 102, 0.2);
  animation: bounce 2s infinite ease-in-out;
}

.error-digit:first-child {
  animation-delay: -0.32s;
}

.error-digit:last-child {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(1) translateY(0);
  }
  40% {
    transform: scale(1.1) translateY(-10px);
  }
}

.error-icon-container {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  border: 4px solid var(--primary-navy);
  box-shadow: 0 8px 25px rgba(0, 51, 102, 0.15);
  position: relative;
  overflow: hidden;
}

.profession-icon {
  font-size: 4rem;
  transition: all 0.5s ease;
  transform: scale(0.8);
}

.profession-icon.animated {
  animation: iconPop 0.6s ease-out;
}

@keyframes iconPop {
  0% {
    transform: scale(0.3) rotate(-180deg);
    opacity: 0;
  }
  50% {
    transform: scale(1.2) rotate(-90deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}

.profession-label {
  font-size: 1.2rem;
  color: var(--secondary-gray);
  font-weight: 600;
  text-transform: capitalize;
  font-family: var(--font-sans);
  opacity: 0.8;
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 0.8;
    transform: translateY(0);
  }
}

/* Main Error Message */
.error-message {
  margin-bottom: 3rem;
}

.error-title {
  font-size: 3rem;
  color: var(--primary-navy);
  margin-bottom: 1rem;
  font-family: var(--font-serif);
}

.error-subtitle {
  font-size: 1.3rem;
  color: var(--secondary-gray);
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
  font-style: italic;
}

/* Suggestions Section */
.error-suggestions {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow: var(--shadow-md);
  border-left: 4px solid var(--cta-primary);
}

.error-suggestions h3 {
  color: var(--primary-navy);
  margin-bottom: 1.5rem;
  font-family: var(--font-serif);
}

.error-suggestions ul {
  list-style: none;
  padding: 0;
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
}

.error-suggestions li {
  padding: 0.75rem 0;
  color: var(--neutral-text);
  border-bottom: 1px solid var(--neutral-border);
  font-size: 1.1rem;
  transition: all 0.3s ease;
}

.error-suggestions li:last-child {
  border-bottom: none;
}

.error-suggestions li:hover {
  color: var(--primary-navy);
  transform: translateX(5px);
}

/* Action Buttons */
.error-actions {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.error-actions .btn-cta {
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  background: linear-gradient(135deg, var(--cta-primary), var(--cta-primary-hover));
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
}

.error-actions .btn-cta:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
  background: linear-gradient(135deg, var(--cta-primary-hover), var(--cta-primary));
}

.error-actions .btn-secondary {
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  background: transparent;
  color: var(--primary-navy);
  border: 2px solid var(--primary-navy);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.error-actions .btn-secondary:hover {
  background: var(--primary-navy);
  color: white;
  transform: translateY(-2px);
}

/* Quick Links Section */
.quick-links {
  margin-bottom: 3rem;
}

.quick-links h4 {
  color: var(--primary-navy);
  margin-bottom: 1.5rem;
  font-family: var(--font-serif);
}

.quick-links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  max-width: 600px;
  margin: 0 auto;
}

.quick-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  background: white;
  border: 2px solid var(--neutral-border);
  border-radius: 8px;
  text-decoration: none;
  color: var(--neutral-text);
  transition: all 0.3s ease;
  font-weight: 500;
}

.quick-link:hover {
  border-color: var(--primary-navy);
  background: var(--neutral-light);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.quick-link-icon {
  font-size: 1.5rem;
  width: 2rem;
  text-align: center;
}

/* Contact Section */
.error-contact {
  margin-top: 3rem;
}

.contact-card {
  background: linear-gradient(135deg, var(--primary-navy), var(--primary-navy-light));
  color: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: var(--shadow-lg);
  max-width: 500px;
  margin: 0 auto;
}

.contact-card h4 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-family: var(--font-serif);
}

.contact-card p {
  margin-bottom: 2rem;
  opacity: 0.9;
  font-size: 1.1rem;
}

.contact-card .btn-outline {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-block;
}

.contact-card .btn-outline:hover {
  background: white;
  color: var(--primary-navy);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .not-found-content {
    padding: 1rem;
  }

  .error-digit {
    font-size: 5rem;
  }

  .error-icon-container {
    width: 80px;
    height: 80px;
  }

  .profession-icon {
    font-size: 2.5rem;
  }

  .error-title {
    font-size: 2rem;
  }

  .error-subtitle {
    font-size: 1.1rem;
  }

  .error-actions {
    flex-direction: column;
    align-items: center;
  }

  .error-actions .btn-cta,
  .error-actions .btn-secondary {
    width: 100%;
    max-width: 300px;
  }

  .quick-links-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .error-suggestions {
    padding: 1.5rem;
  }

  .contact-card {
    padding: 2rem;
  }
}

@media (max-width: 480px) {
  .error-digit {
    font-size: 4rem;
  }

  .error-icon-container {
    width: 70px;
    height: 70px;
  }

  .profession-icon {
    font-size: 2rem;
  }

  .error-title {
    font-size: 1.7rem;
  }

  .error-subtitle {
    font-size: 1rem;
  }

  .error-suggestions ul {
    font-size: 1rem;
  }

  .contact-card {
    padding: 1.5rem;
  }
}

/* Fun loading animation for page entrance */
.not-found-container {
  animation: slideIn 0.8s ease-out;
}

@keyframes slideIn {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/NotFound.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,oCAAoC;EACtC;EACA;IACE,gCAAgC;IAChC,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,8CAA8C;EAC9C,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iFAAiF;EACjF,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,iFAAiF;AACnF;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,uCAAuC;EACvC,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* 404 Not Found Page - Professional yet Playful */\n\n.not-found-container {\n  min-height: calc(100vh - 300px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 0;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n}\n\n.not-found-content {\n  max-width: 800px;\n  text-align: center;\n  padding: 2rem;\n}\n\n/* Animated 404 Section */\n.error-code-section {\n  margin-bottom: 3rem;\n}\n\n.error-code {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.error-digit {\n  font-size: 8rem;\n  font-weight: 900;\n  font-family: var(--font-serif);\n  color: var(--primary-navy);\n  text-shadow: 0 4px 8px rgba(0, 51, 102, 0.2);\n  animation: bounce 2s infinite ease-in-out;\n}\n\n.error-digit:first-child {\n  animation-delay: -0.32s;\n}\n\n.error-digit:last-child {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(1) translateY(0);\n  }\n  40% {\n    transform: scale(1.1) translateY(-10px);\n  }\n}\n\n.error-icon-container {\n  width: 120px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border-radius: 50%;\n  border: 4px solid var(--primary-navy);\n  box-shadow: 0 8px 25px rgba(0, 51, 102, 0.15);\n  position: relative;\n  overflow: hidden;\n}\n\n.profession-icon {\n  font-size: 4rem;\n  transition: all 0.5s ease;\n  transform: scale(0.8);\n}\n\n.profession-icon.animated {\n  animation: iconPop 0.6s ease-out;\n}\n\n@keyframes iconPop {\n  0% {\n    transform: scale(0.3) rotate(-180deg);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.2) rotate(-90deg);\n  }\n  100% {\n    transform: scale(1) rotate(0deg);\n    opacity: 1;\n  }\n}\n\n.profession-label {\n  font-size: 1.2rem;\n  color: var(--secondary-gray);\n  font-weight: 600;\n  text-transform: capitalize;\n  font-family: var(--font-sans);\n  opacity: 0.8;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 0.8;\n    transform: translateY(0);\n  }\n}\n\n/* Main Error Message */\n.error-message {\n  margin-bottom: 3rem;\n}\n\n.error-title {\n  font-size: 3rem;\n  color: var(--primary-navy);\n  margin-bottom: 1rem;\n  font-family: var(--font-serif);\n}\n\n.error-subtitle {\n  font-size: 1.3rem;\n  color: var(--secondary-gray);\n  line-height: 1.6;\n  max-width: 600px;\n  margin: 0 auto;\n  font-style: italic;\n}\n\n/* Suggestions Section */\n.error-suggestions {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 3rem;\n  box-shadow: var(--shadow-md);\n  border-left: 4px solid var(--cta-primary);\n}\n\n.error-suggestions h3 {\n  color: var(--primary-navy);\n  margin-bottom: 1.5rem;\n  font-family: var(--font-serif);\n}\n\n.error-suggestions ul {\n  list-style: none;\n  padding: 0;\n  text-align: left;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.error-suggestions li {\n  padding: 0.75rem 0;\n  color: var(--neutral-text);\n  border-bottom: 1px solid var(--neutral-border);\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n}\n\n.error-suggestions li:last-child {\n  border-bottom: none;\n}\n\n.error-suggestions li:hover {\n  color: var(--primary-navy);\n  transform: translateX(5px);\n}\n\n/* Action Buttons */\n.error-actions {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  margin-bottom: 3rem;\n  flex-wrap: wrap;\n}\n\n.error-actions .btn-cta {\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  background: linear-gradient(135deg, var(--cta-primary), var(--cta-primary-hover));\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);\n}\n\n.error-actions .btn-cta:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);\n  background: linear-gradient(135deg, var(--cta-primary-hover), var(--cta-primary));\n}\n\n.error-actions .btn-secondary {\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  background: transparent;\n  color: var(--primary-navy);\n  border: 2px solid var(--primary-navy);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.error-actions .btn-secondary:hover {\n  background: var(--primary-navy);\n  color: white;\n  transform: translateY(-2px);\n}\n\n/* Quick Links Section */\n.quick-links {\n  margin-bottom: 3rem;\n}\n\n.quick-links h4 {\n  color: var(--primary-navy);\n  margin-bottom: 1.5rem;\n  font-family: var(--font-serif);\n}\n\n.quick-links-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.quick-link {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  background: white;\n  border: 2px solid var(--neutral-border);\n  border-radius: 8px;\n  text-decoration: none;\n  color: var(--neutral-text);\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.quick-link:hover {\n  border-color: var(--primary-navy);\n  background: var(--neutral-light);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.quick-link-icon {\n  font-size: 1.5rem;\n  width: 2rem;\n  text-align: center;\n}\n\n/* Contact Section */\n.error-contact {\n  margin-top: 3rem;\n}\n\n.contact-card {\n  background: linear-gradient(135deg, var(--primary-navy), var(--primary-navy-light));\n  color: white;\n  padding: 2.5rem;\n  border-radius: 16px;\n  box-shadow: var(--shadow-lg);\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.contact-card h4 {\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n  font-family: var(--font-serif);\n}\n\n.contact-card p {\n  margin-bottom: 2rem;\n  opacity: 0.9;\n  font-size: 1.1rem;\n}\n\n.contact-card .btn-outline {\n  background: transparent;\n  color: white;\n  border: 2px solid white;\n  padding: 0.75rem 2rem;\n  border-radius: 6px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  display: inline-block;\n}\n\n.contact-card .btn-outline:hover {\n  background: white;\n  color: var(--primary-navy);\n  transform: translateY(-2px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .not-found-content {\n    padding: 1rem;\n  }\n\n  .error-digit {\n    font-size: 5rem;\n  }\n\n  .error-icon-container {\n    width: 80px;\n    height: 80px;\n  }\n\n  .profession-icon {\n    font-size: 2.5rem;\n  }\n\n  .error-title {\n    font-size: 2rem;\n  }\n\n  .error-subtitle {\n    font-size: 1.1rem;\n  }\n\n  .error-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .error-actions .btn-cta,\n  .error-actions .btn-secondary {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .quick-links-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .error-suggestions {\n    padding: 1.5rem;\n  }\n\n  .contact-card {\n    padding: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .error-digit {\n    font-size: 4rem;\n  }\n\n  .error-icon-container {\n    width: 70px;\n    height: 70px;\n  }\n\n  .profession-icon {\n    font-size: 2rem;\n  }\n\n  .error-title {\n    font-size: 1.7rem;\n  }\n\n  .error-subtitle {\n    font-size: 1rem;\n  }\n\n  .error-suggestions ul {\n    font-size: 1rem;\n  }\n\n  .contact-card {\n    padding: 1.5rem;\n  }\n}\n\n/* Fun loading animation for page entrance */\n.not-found-container {\n  animation: slideIn 0.8s ease-out;\n}\n\n@keyframes slideIn {\n  0% {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
